import action from "../helpers/rest-client";

export class ErrorPago extends Error {}

class Pago {
	public new(payload) {
		return action
			.Post({
				url: "/pagos",
				body: payload,
			})
			.then((response) => {
				return { response };
			})
			.catch((error) => {
				return { error };
			});
	}

	public edit({ itemId, ...rest }) {
		return action
			.Patch({
				url: `/pagos/${itemId}`,
				body: rest,
			})
			.then((response) => {
				return { response };
			})
			.catch((error) => {
				return { error };
			});
	}

	public getAll({ page, limit, filters, query }) {
		const queryString = new URLSearchParams(filters).toString();

		return action
			.Get({
				url: `/pagos?${!!query ? `query=${query}` : ""}&offset=${
					page * limit
				}&limit=${limit}${!!queryString ? `&${queryString}` : ""}`,
			})
			.then((response) => {
				return { response };
			})
			.catch((error) => {
				return { error };
			});
	}

	public getOne({ itemId }) {
		return action
			.Get({
				url: `/pagos/${itemId}`,
			})
			.then((response) => {
				return { response };
			})
			.catch((error) => {
				return { error };
			});
	}

	public delete({ itemId }) {
		return action
			.Del({
				url: `/pagos/${itemId}`,
			})
			.then((response) => {
				return { response };
			})
			.catch((error) => {
				return { error };
			});
	}

	public getFiles({ itemId }) {
		return action
			.Get({
				url: `/pagos/files/${itemId}`,
			})
			.then((response) => {
				return { response };
			})
			.catch((error) => {
				return { error };
			});
	}

	public getComments({ itemId }) {
		return action
			.Get({
				url: `/pagos/comments/${itemId}`,
			})
			.then((response) => {
				return { response };
			})
			.catch((error) => {
				return { error };
			});
	}

	public getStatics() {
		return action
			.Get({
				url: "/pagos/static",
			})
			.then((response) => {
				return { response };
			})
			.catch((error) => {
				return { error };
			});
	}
}

const pago = new Pago();
export default pago;
